module.exports = __webpack_public_path__ + "img/bill-1.660d8385.png";